module.exports = __webpack_public_path__ + "img/block0Img04.ec53190f.png";